/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeAccountBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeAccountBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.StripeAccountEventObject = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.StripeAccountBean);
  }
}(this, function(ApiClient, StripeAccountBean) {
  'use strict';

  /**
   * The StripeAccountEventObject model module.
   * @module model/StripeAccountEventObject
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeAccountEventObject</code>.
   * @alias module:model/StripeAccountEventObject
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeAccountEventObject</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeAccountEventObject} obj Optional instance to populate.
   * @return {module:model/StripeAccountEventObject} The populated <code>StripeAccountEventObject</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('object'))
        obj._object = StripeAccountBean.constructFromObject(data['object']);
    }
    return obj;
  }

  /**
   * @member {module:model/StripeAccountBean} _object
   */
  exports.prototype._object = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/StripeAccountEventObject.js